<script lang="ts">
  import type { Action } from "svelte/action";
  import ContextMenu from "../invoices/ContextMenu.svelte";
  import { type DropdownMenuAttributes, type MenuParams } from "../dropdown-menu/create";
  import { FILTER_MENU_MIN_WIDTH } from "../invoices/constants";
  import FilterMenuItem from "../invoices/FilterMenuItem.svelte";
  import type { FilterItem } from "../../helpers/types";
  import isEmpty from "lodash/isEmpty";

  export let menuAttrs: DropdownMenuAttributes;
  export let isOpen: boolean;
  export let action: Action<HTMLElement, MenuParams, Record<never, any>>;
  export let menuOptions: MenuParams;
  export let items: FilterItem[] | undefined;
  export let selected: Record<string, boolean> = {};

  function toggleAllChats() {
    if (!items) {
      return;
    }
    if (isEmpty(selected) || items.every((i) => selected[i.id])) {
      for (const i of items) {
        selected[i.id] = false;
      }
      return;
    }

    selected = {};
  }
</script>

{#if isOpen}
  <ContextMenu {...menuAttrs} {action} {menuOptions} --filter-menu-minW={FILTER_MENU_MIN_WIDTH}>
    <FilterMenuItem on:click={toggleAllChats} title="toggle all suppliers" titleSize="s" />
    {#if items}
      {#each items as item (item.id)}
        <FilterMenuItem
          title={item.title}
          titleSize="s"
          subtitle={item.subtitle}
          selected={isEmpty(selected) ? true : selected[item.id]}
          unavailable={false}
          on:click={() => {
            if (!items) {
              return;
            }
            if (isEmpty(selected)) {
              for (const i of items) {
                selected[i.id] = true;
              }
            }

            selected[item.id] = !selected[item.id];

            if (items.every((i) => selected[i.id] === true)) {
              selected = {};
            }
          }}
        />
      {/each}
    {/if}
  </ContextMenu>
{/if}
